import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { useState, useEffect } from 'react';
import consent from '@buzzfeed/bf-utils/lib/consent';

var framework = consent.framework,
    rules = consent.rules;
function useConsent() {
  var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tracking';
  var needsConsent = framework.needsConsent();
  /**
   * On server render, need for consent will never be known (relies on window and browser cookies)
   *  If on client, consent can be considered 'known' from the start if determined it is not needed
   */

  var _useState = useState(!needsConsent || framework.isConsentStringCookieSet()),
      _useState2 = _slicedToArray(_useState, 2),
      isConsentKnown = _useState2[0],
      setIsConsentKnown = _useState2[1];

  var _useState3 = useState(!needsConsent),
      _useState4 = _slicedToArray(_useState3, 2),
      isConsentReady = _useState4[0],
      setIsConsentReady = _useState4[1];

  var _useState5 = useState(!needsConsent),
      _useState6 = _slicedToArray(_useState5, 2),
      consentValue = _useState6[0],
      setConsentValue = _useState6[1];

  useEffect(function () {
    var checkConsent = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var value;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return rules.hasConsented(action);

              case 2:
                value = _context.sent;
                setConsentValue(value);
                setIsConsentKnown(true);
                setIsConsentReady(true);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function checkConsent() {
        return _ref.apply(this, arguments);
      };
    }();

    if (needsConsent) {
      checkConsent();
    }
  }, [action, needsConsent]);
  return {
    consentValue: consentValue,
    isConsentKnown: isConsentKnown,
    isConsentReady: isConsentReady
  };
}

export { useConsent as default };
